/**
 * Single source of truth for routes and backend endpoint names.
 * Mirrors `Paratag-Website/src/config/appConfig.ts`.
 */
const appConfig = {
  paths: {
    home: "/",
    flyIn: "/fly-in",
    memorial: "/memorial",
    contact: "/contact",
  },
  apis: {
    // Bases are full hostnames (no scheme, no leading slash).
    waiverBaseUrl: process.env.REACT_APP_WAIVER_API_BASE_URL ?? "",
    contactBaseUrl: process.env.REACT_APP_CONTACT_API_BASE_URL ?? "",
    signWaiver: "signWaiver",
    sendContact: "sendContact",
  },
  flyIn: {
    venmoHandle: process.env.REACT_APP_VENMO_HANDLE ?? "WesternPAParamotors",
    feeUsd: Number(process.env.REACT_APP_FLYIN_FEE_USD ?? "20"),
    eventDate: process.env.REACT_APP_FLYIN_EVENT_DATE ?? "",
    eventEndDate: process.env.REACT_APP_FLYIN_EVENT_END_DATE ?? "",
  },
  clubName: "Western PA Paramotors",
} as const;

export default appConfig;
